/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createImageWatermarkUploadResponseFromDiscriminatorValue, serializeImageWatermarkUploadResponse, serializeInitiateImageWatermarkUploadRequest, type HttpValidationProblemDetails, type IError, type ImageWatermarkUploadResponse, type InitiateImageWatermarkUploadRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /image-watermarks/upload/initiate
 */
export interface InitiateRequestBuilder extends BaseRequestBuilder<InitiateRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ImageWatermarkUploadResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: InitiateImageWatermarkUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ImageWatermarkUploadResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InitiateImageWatermarkUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InitiateRequestBuilderUriTemplate = "{+baseurl}/image-watermarks/upload/initiate";
/**
 * Metadata for all the requests in the request builder.
 */
export const InitiateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: InitiateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createImageWatermarkUploadResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInitiateImageWatermarkUploadRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
